import {connect} from "react-redux";
import UCDActivitySave from "./Save";
import {bindActionCreators} from "redux";
import { documentUploadUrlPublic } from "../../../../../service/fileUpload/action";
import {markAttendances, getActivity, userCheckout, activityTypes, newActivity, dealerById, getSenior} from "../../../../../service/Dealer/action";
import {saveActivity} from "../../../../../service/DCC/action";
const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    markAttendanceDetails:state.Dealer.markAttendance,
    getActivityDetails:state.Dealer.getActivity,
    isCheckoutDetails:state.Dealer.isCheckoutDetails,
    dealerByIdDetails:state.Dealer.dealerById,
    activityTypesDetails:state.Dealer.activityTypesDetails,
    NewActivityDetails:state.DCC.saveActivityRes,
    senior:state.Dealer.senior,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            markAttendances,
            newActivity,
            userCheckout,
            saveActivity
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(UCDActivitySave);
